import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Aside from '@/view/layout/aside';
import HistoryComponent from '@/view/layout/aside/historyComponent/history';
import Screenfull from '@/view/layout/screenfull';
import Search from '@/view/layout/search/search';
import BottomInfo from '@/view/layout/bottomInfo/bottomInfo';
import { mapGetters, mapActions } from 'vuex';
import CustomPic from '@/components/customPic';
import { Common } from '@/utils/common';
export default {
  name: 'Layout',
  components: {
    Aside: Aside,
    HistoryComponent: HistoryComponent,
    Screenfull: Screenfull,
    Search: Search,
    BottomInfo: BottomInfo,
    CustomPic: CustomPic
  },
  data: function data() {
    return {
      show: false,
      isCollapse: false,
      isSider: true,
      isMobile: true,
      isShadowBg: false,
      loadingFlag: false,
      reloadFlag: true,
      value: '',
      echartsTimer: true
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters('user', ['userInfo'])), {}, {
    title: function title() {
      return this.$route.meta.title || '当前页面';
    },
    matched: function matched() {
      return this.$route.matched;
    }
  }),
  mounted: function mounted() {
    var _this = this;

    var screenWidth = document.body.clientWidth;

    if (screenWidth < 1000) {
      this.isMobile = true;
      this.isSider = false;
      this.isCollapse = true;
      Common.isMobile = true;
    } else if (screenWidth >= 1000 && screenWidth < 1200) {
      this.isMobile = false;
      this.isSider = false;
      this.isCollapse = true;
      Common.isMobile = false;
    } else {
      this.isMobile = false;
      this.isSider = true;
      this.isCollapse = false;
      Common.isMobile = false;
    }

    this.$bus.emit('collapse', this.isCollapse);
    this.$bus.emit('mobile', this.isMobile);
    this.$bus.on('reload', this.reload);
    this.$bus.on('showLoading', function () {
      _this.loadingFlag = true;
    });
    this.$bus.on('closeLoading', function () {
      _this.loadingFlag = false;
    });

    window.onresize = function () {
      return function () {
        var screenWidth = document.body.clientWidth;

        if (screenWidth < 1000) {
          _this.isMobile = true;
          _this.isSider = false;
          _this.isCollapse = true;
          Common.isMobile = true;
        } else if (screenWidth >= 1000 && screenWidth < 1200) {
          _this.isMobile = false;
          _this.isSider = false;
          _this.isCollapse = true;
          Common.isMobile = false;
        } else {
          _this.isMobile = false;
          _this.isSider = true;
          _this.isCollapse = false;
          Common.isMobile = false;
        }

        _this.$bus.emit('collapse', _this.isCollapse);

        _this.$bus.emit('mobile', _this.isMobile);

        _this.refreshEcharts();
      }();
    };
  },
  methods: _objectSpread(_objectSpread({}, mapActions('user', ['LoginOut'])), {}, {
    reload: function reload() {
      var _this2 = this;

      this.reloadFlag = false;
      this.$nextTick(function () {
        _this2.reloadFlag = true;
      });
    },
    totalCollapse: function totalCollapse() {
      this.isCollapse = !this.isCollapse;
      this.isSider = !this.isCollapse;
      this.isShadowBg = !this.isCollapse;
      this.$bus.emit('collapse', this.isCollapse);
      this.refreshEcharts();
    },
    toPerson: function toPerson() {
      this.$router.push({
        name: 'person'
      });
    },
    changeShadow: function changeShadow() {
      this.isShadowBg = !this.isShadowBg;
      this.isSider = !!this.isCollapse;
      this.totalCollapse();
    },
    refreshEcharts: function refreshEcharts() {
      var _this3 = this;

      if (this.echartsTimer && Common.echarts.length > 0) {
        console.log('window.onresize');
        this.echartsTimer = false;
        setTimeout(function () {
          Common.echarts.forEach(function (item) {
            item.resize();
          });
          _this3.echartsTimer = true;
        }, 500);
      }
    }
  })
};